import { GeneralFaqsContainer } from '@/modules/GeneralFaq';

export const GeneralFaqs = (): JSX.Element => <GeneralFaqsContainer />;

export default GeneralFaqs;
